<!-- <div class="dashboard">
 <div (click)="displayTab=0">Work Review</div>
 <div (click)="displayTab=1">Standards Management</div>
 <div (click)="displayTab=2">User Management</div>
</div> -->


<div class="dashboard">
<nav class="navbar navbar-expand navclass">
    <div class="container">
    <ul class="navbar-nav">
      <li class="nav-item ml-3 mr-3">
        <a class="nav-link nr-navbar-text" routerLink="/dashboard" routerLinkActive="nav-admin-active">Work Review</a>
      </li>
      <li class="nav-item ml-3 mr-3">
        <a class="nav-link nr-navbar-text" routerLinkActive="nav-admin-active">Standards Management</a>
      </li>
      <li class="nav-item ml-3 mr-3">
        <a class="nav-link nr-navbar-text" routerLink="/usermanagement" routerLinkActive="nav-admin-active">User Management</a>
      </li>
    </ul>
  </div>
  </nav>
</div>


